import { Component, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { FormArray, FormGroup, FormControl } from '@angular/forms';
import { RestService } from '../services/rest.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { ToastService, MsiModalRef, ModalService } from '@msi/cobalt';
import { TenantSettings } from '../services/tenant-settings.service';

@Component({
  selector: 'app-types-proximities-page',
  templateUrl: './types-proximities-page.component.html',
})
export class TypesProximitiesPageComponent implements OnInit, OnDestroy {
  @ViewChild('typedelete', { static: true }) typedelete: TemplateRef<any>;
  private TypeDeleteComfirm: MsiModalRef;
  delettypeindex;
  currentAgency;
  currentCustomer;
  switchAgencyEventListener;
  beSwitched = false;
  editEnabled = true;
  ReadyListener;
  CustomerIDListener;
  UnitTypes = ['Foot', 'Meter', 'Mile', 'Kilometers'];
  typeProximityFormArray = new FormArray([]);
  defaultInnerDistance = 500;
  defaultOuterDistance = 1000;
  defaultUnit = 'Foot';
  defaultSettings = {
    innerProximityDistance: 500,
    outerProximityDistance: 1000,
    unitOfMeasure: 'Foot',
    agencyId: '',
    id: 0,
    tenantKey: 0,
  };
  editMode = false;
  // below is for buffer row (for further input) default settings
  newrowType = new FormControl('');
  newrowDescription = new FormControl('');
  newrowDirectHitVA = new FormControl(false);
  newrowDirectHitAA = new FormControl(false);
  newrowInnerDistance = new FormControl();
  newrowInnerAA = new FormControl(false);
  newrowInnerVA = new FormControl(false);
  newrowOuterDistance = new FormControl();
  newrowOuterAA = new FormControl(false);
  newrowOuterVA = new FormControl(false);
  newrowSequence = new FormControl(999);
  Schema: Array<any>;
  deleteTypeList = new Array();
  // tslint:disable-next-line:no-construct

  constructor(
    public rest: RestService,
    public router: Router,
    public toastService: ToastService,
    private modalService: ModalService,
    private tenantSettings: TenantSettings
  ) {}
  ngOnDestroy(): void {
    if (this.switchAgencyEventListener !== undefined) {
      this.switchAgencyEventListener.unsubscribe();
    }
    /* istanbul ignore else */
    if (this.ReadyListener !== undefined) {
      this.ReadyListener.unsubscribe();
    }
    if (this.CustomerIDListener !== undefined) {
      this.CustomerIDListener.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.tenantSettings.editEnabled.subscribe(val => {
      this.editEnabled = val;
      
    });
    this.ReadyListener = this.rest.Ready.subscribe((ready) => {
      if (ready === true) {
        this.CustomerIDListener = this.rest.currCustomer.subscribe((customer) => {
          this.currentCustomer = customer;
        });
        this.switchAgencyEventListener = this.rest.currentAgency.subscribe((agencyName) => {
          this.currentAgency = agencyName;
          if (this.beSwitched) {
            this.switchAgency(this.currentCustomer, this.currentAgency);
          } else {
            this.beSwitched = true;
            this.load_data(this.currentCustomer, this.currentAgency);
          }
        });
      }
    });
  }

  // logic of inner and outer distance
  public confirmdefaultvalue() {
    if (this.defaultInnerDistance < 0 || this.defaultOuterDistance < 0) {
      this.toastService.warning('Inner and outer distance cannot be smaller than zero');
      return; // Inner and outer distance should be postive
    } else {
      if (this.defaultInnerDistance > this.defaultOuterDistance) {
        this.toastService.warning('Inner distance can not be larger than outer distance');
        return; // outer distance should be larger than inner distance
      } else {
        const updateDefaultValue = {
          InnerProximityDistance: this.defaultInnerDistance,
          OuterProximityDistance: this.defaultOuterDistance,
          UnitOfMeasure: this.defaultUnit,
          AgencyId: this.defaultSettings.agencyId,
          Id: this.defaultSettings.id,
          TenantKey: this.defaultSettings.tenantKey,
        };
        console.log(updateDefaultValue);
        this.rest
          .update_defaultproximity(updateDefaultValue, this.currentCustomer, this.currentAgency)
          .toPromise()
          .then(
            (res) => {
              this.toastService.success('Update Agency Default Proximity Value Successfully!', undefined, {
                autoDismiss: true && 3000,
              });
              this.defaultSettings.outerProximityDistance = this.defaultOuterDistance;
              this.defaultSettings.innerProximityDistance = this.defaultInnerDistance;
              this.defaultSettings.unitOfMeasure = this.defaultUnit;
              // window.location.reload();
            },
            (err) => {
              console.log(err);
              this.toastService.warning('Update Fails!');
            }
          );
      }
    }
  }

  removerow(i) {
    console.log(this.typeProximityFormArray.controls[i]);
    /* istanbul ignore else */
    if (this.typeProximityFormArray.value[i].PremiseHazardTypeKey) {
      this.deleteTypeList.push(this.typeProximityFormArray.value[i].PremiseHazardTypeKey);
      console.log(this.deleteTypeList);
    }
    this.typeProximityFormArray.removeAt(i);
  }

  public addWarningToast() {
    if (this.newrowDescription.value === '' && this.newrowType.value === '') {
      this.toastService.warning('Please add Hazard Type and Hazard Description');
      // required input: hazard type and hazard description
    } else {
      if (this.newrowDescription.value === '') {
        this.toastService.warning('Please add Hazard Description');
      }
      if (this.newrowType.value === '') {
        this.toastService.warning('Please add Hazard Type');
      }
    }
  }

  addandconfirmrow() {
    if (this.newrowDescription.value === '' || this.newrowType.value === '') {
      this.addWarningToast();
    } else {
      const newrowinputgroup = new FormGroup({
        Code: new FormControl(''),
        Description: new FormControl(''),
        DirectHitVisual: new FormControl(),
        DirectHitAudio: new FormControl(),
        InnerProximityDistance: new FormControl(),
        InnerProximityAudio: new FormControl(),
        InnerProximityVisual: new FormControl(),
        OuterProximityDistance: new FormControl(),
        OuterProximityAudio: new FormControl(),
        OuterProximityVisual: new FormControl(),
        DisplayOrder: new FormControl(),
        AgencyId: new FormControl(''),
        TenantKey: new FormControl(),
        CustomerId: new FormControl(''),
      });
      if (!this.newrowInnerDistance.value && this.newrowInnerDistance.value !== 0) {
        this.newrowInnerDistance.setValue(this.defaultInnerDistance);
      }
      if (!this.newrowOuterDistance.value && this.newrowOuterDistance.value !== 0) {
        this.newrowOuterDistance.setValue(this.defaultOuterDistance);
      }
      if (this.newrowInnerDistance.value < 0 || this.newrowOuterDistance.value < 0) {
        this.toastService.warning('Distance must be postive');
        this.newrowInnerDistance.reset();
        this.newrowOuterDistance.reset();
      } else {
        if (this.newrowInnerDistance.value > this.newrowOuterDistance.value) {
          this.toastService.warning('Fail to add new record, inner distance cannot be larger than outer distance');
          this.newrowInnerDistance.reset();
          this.newrowOuterDistance.reset();
        } else {
          console.log(this.newrowInnerDistance.value);
          console.log(this.rest.unitConvert.get(this.defaultSettings.unitOfMeasure));
          newrowinputgroup.setValue({
            Code: this.newrowType.value,
            Description: this.newrowDescription.value,
            DirectHitVisual: this.newrowDirectHitVA.value,
            DirectHitAudio: this.newrowDirectHitAA.value,
            InnerProximityDistance:
              (this.newrowInnerDistance.value * this.rest.unitConvert.get(this.defaultSettings.unitOfMeasure)),
            InnerProximityAudio: this.newrowInnerAA.value,
            InnerProximityVisual: this.newrowInnerVA.value,
            OuterProximityDistance:
              (this.newrowOuterDistance.value * this.rest.unitConvert.get(this.defaultSettings.unitOfMeasure)),
            OuterProximityAudio: this.newrowOuterAA.value,
            OuterProximityVisual: this.newrowOuterVA.value,
            DisplayOrder: this.newrowSequence.value,
            AgencyId: this.currentAgency,
            CustomerId: this.currentCustomer,
            TenantKey: 0,
          });
          console.log(newrowinputgroup);
          this.typeProximityFormArray.push(newrowinputgroup);
          this.clearNewRow();
        }
      }
    }
  }

  clearNewRow() {
    this.newrowType.setValue('');
    this.newrowDescription.setValue('');
    this.newrowDirectHitVA.reset();
    this.newrowDirectHitAA.reset();
    this.newrowInnerDistance.reset();
    this.newrowInnerAA.reset();
    this.newrowInnerVA.reset();
    this.newrowOuterDistance.reset();
    this.newrowOuterAA.reset();
    this.newrowOuterVA.reset();
    this.newrowSequence.reset(999);
  }

  public load_data(CustomerId, AgencyId) {
    this.load_defaultproximity(this.currentCustomer, this.currentAgency);
    this.rest
      .get_typeproximityschema(CustomerId, AgencyId)
      .toPromise()
      .then(
        (data) => {
          this.Schema = data;
          console.log(this.Schema);
          /* istanbul ignore else */
          if (this.Schema != null) {
            this.loadformarray();
          }
        },
        (err) => {
          if (err.status === 400 || err.status === 500) {
            this.toastService.error('Fail to load premise hazard types! - ' + err.error);
          } else {
            /* istanbul ignore else */
            if (err.status !== 404) {
              this.toastService.error('Fail to load premise hazard types! - ' + err.statusText);
            }
            console.log(err);
          }
          this.typeProximityFormArray = new FormArray([]);
        }
      );
  }

  public loadformarray() {
    for (const i of this.Schema) {
      const initialrow = new FormGroup({
        PremiseHazardTypeKey: new FormControl(''),
        TenantKey: new FormControl(''),
        AgencyId: new FormControl(''),
        Code: new FormControl(''),
        Description: new FormControl(''),
        DirectHitVisual: new FormControl(''),
        DirectHitAudio: new FormControl(''),
        InnerProximityDistance: new FormControl(''),
        InnerProximityAudio: new FormControl(''),
        InnerProximityVisual: new FormControl(''),
        OuterProximityDistance: new FormControl(''),
        OuterProximityAudio: new FormControl(''),
        OuterProximityVisual: new FormControl(''),
        DisplayOrder: new FormControl(''),
      });
      initialrow.patchValue({
        PremiseHazardTypeKey: i.premiseHazardTypeKey,
        AgencyId: i.agencyId,
        TenantKey: i.tenantKey,
        Code: i.code,
        Description: i.description,
        DirectHitVisual: i.directHitVisual,
        DirectHitAudio: i.directHitAudio,
        InnerProximityDistance: i.innerProximityDistance,
        InnerProximityAudio: i.innerProximityAudio,
        InnerProximityVisual: i.innerProximityVisual,
        OuterProximityDistance: i.outerProximityDistance,
        OuterProximityAudio: i.outerProximityAudio,
        OuterProximityVisual: i.outerProximityVisual,
        DisplayOrder: i.displayOrder,
      });
      this.typeProximityFormArray.push(initialrow);
    }
    console.log(this.typeProximityFormArray);
  }

  public async update_data() {
    let validdata = true;
    for (const element of this.typeProximityFormArray.value) {
      /* istanbul ignore else */
      if (element.InnerProximityDistance > element.OuterProximityDistance) {
        this.toastService.warning('Inner distance can not be larger than outer distance');
        return;
      }
    }
    const createSchema = new Array();
    const updateSchema = new Array();
    this.typeProximityFormArray.controls.forEach((element) => {
      if (!element.value.Code.match(/^[a-zA-Z0-9.-\s_]+$/) || !element.value.Description.match(/^[a-zA-Z0-9.-\s_]+$/)) {
        validdata = false;
      }
      if (!element.value.PremiseHazardTypeKey) {
        createSchema.push(element.value);
      } else {
        // the data was changed
        if (element.pristine === false || element.dirty === false) {
          updateSchema.push(element.value);
        }
      }
    });
    console.log(createSchema);
    console.log(updateSchema);
    console.log(this.deleteTypeList);
    if (validdata) {
      if (this.deleteTypeList.length) {
        await this.rest
          .delete_Type(this.deleteTypeList.join(','), this.currentCustomer, this.currentAgency)
          .toPromise()
          .then(
            (res) => {
              this.toastService.success('Deleted Successfully!');
            },
            (err: HttpErrorResponse) => {
              if (err.status === 500) {
                this.toastService.error('Fail to delete premise hazard type! - ' + err.error);
              } else {
                this.toastService.error('Fail to delete premise hazard type - ' + err.statusText);
                console.log(err);
              }
            }
          );
      }
      /* istanbul ignore else */
      if (updateSchema.length !== 0) {
        await this.rest
          .update_Type(updateSchema, this.currentCustomer, this.currentAgency)
          .toPromise()
          .then(
            (res) => {
              this.toastService.success('Updated Successfully!');
            },
            (err: HttpErrorResponse) => {
              if (err.status === 500) {
                this.toastService.error('Fail to update premise hazard type! - ' + err.error);
              } else {
                this.toastService.error('Fail to update premise hazard type! - ' + err.statusText);
                console.log(err);
              }
            }
          );
      }
      /* istanbul ignore else */
      if (createSchema.length !== 0) {
        await this.rest
          .create_Type(createSchema, this.currentCustomer, this.currentAgency)
          .toPromise()
          .then(
            (res) => {
              console.log(res);
              this.toastService.success('Create new type record Successfully! ' + res.body);
            },
            (err: HttpErrorResponse) => {
              if (err.status === 400 || err.status === 500) {
                this.toastService.error('Fail to create premise hazard type! - ' + err.error);
              } else {
                this.toastService.error('Fail to create premise hazard type! - ' + err.statusText);
                console.log(err);
              }
            }
          );
      }
    } else {
      this.toastService.error('Type Name and Description cannot contain special characters other than . - and _.');
    }
    // this.InitialSchema = this.Schema;
    this.typeProximityFormArray.clear();
    this.Schema = null;
    this.clearNewRow();
    while (this.deleteTypeList.length) {
      this.deleteTypeList.pop();
    }
    /* istanbul ignore next */
    this.rest
      .get_typeproximityschema(this.currentCustomer, this.currentAgency)
      .toPromise()
      .then(
        (data) => {
          this.Schema = data; // copy for reset button
          console.log(this.Schema);
          if (this.Schema != null) {
            this.loadformarray();
          }
        },
        (err) => {
          if (err.status === 500) {
            this.toastService.error('Fail to load premise hazard types! - ' + err.error);
          } else {
            if (err.status !== 404) {
              this.toastService.error('Fail to load premise hazard types! - ' + err.statusText);
            }
            console.log(err);
          }
          this.typeProximityFormArray = new FormArray([]);
        }
      );
  }

  reset_data() {
    while (this.deleteTypeList.length) {
      this.deleteTypeList.pop();
    }
    this.clearNewRow();
    this.typeProximityFormArray.clear();
    this.loadformarray();
    this.defaultOuterDistance = this.defaultSettings.outerProximityDistance;
    this.defaultInnerDistance = this.defaultSettings.innerProximityDistance;
    this.defaultUnit = this.defaultSettings.unitOfMeasure;
  }
  /* istanbul ignore next */
  DeleteTypeCancel() {
    this.TypeDeleteComfirm.close();
  }
  /* istanbul ignore next */
  DeleteTypeConfirm() {
    this.TypeDeleteComfirm.close();
    this.removerow(this.delettypeindex);
  }
  /* istanbul ignore next */
  confirmBeforeDeleteType(i) {
    this.delettypeindex = i;
    this.TypeDeleteComfirm = this.modalService.open(this.typedelete, {
      disableClose: true,
      hasBackdrop: true,
    });
  }

  edit_mode_change() {
    const editinput = document.getElementsByClassName('disabledinput');
    if (this.editMode === false) {
      console.log(editinput);
      for (const i of editinput) {
        i.removeAttribute('disabled');
      }
    } else {
      for (const j of editinput) {
        j.setAttribute('disabled', 'true');
      }
    }
    this.editMode = !this.editMode;
  }

  load_defaultproximity(CustomerId, AgencyId) {
    this.rest
      .get_defaultproximity(CustomerId, AgencyId)
      .toPromise()
      .then(
        (res) => {
          /* istanbul ignore else */
          if (res !== null) {
            let data: any;
            data = res;
            this.defaultSettings = data;
            this.defaultUnit = this.defaultSettings.unitOfMeasure;
            this.rest.changeDefaultDistanceUnit(this.defaultUnit);
            this.defaultInnerDistance = this.defaultSettings.innerProximityDistance;
            this.defaultOuterDistance = this.defaultSettings.outerProximityDistance;
          }
        },
        (err) => {
          if (err.status === 400 || err.status === 500) {
            this.toastService.error(
              'Fail to load default inner distance, outter distance and measure unit! - ' + err.error
            );
          } else {
            /* istanbul ignore else */
            if (err.status !== 404) {
              this.toastService.error(
                'Fail to load default inner distance, outter distance and measure unit! - ' + err.statusText
              );
            }
            console.log(err);
          }
        }
      );
  }

  public createAgencyDefault() {
    const defaultSettings = {
      InnerProximityDistance: this.defaultInnerDistance,
      OuterProximityDistance: this.defaultOuterDistance,
      UnitOfMeasure: this.defaultUnit,
      AgencyId: this.currentAgency,
      CustomerId: this.currentCustomer,
    };
    console.log(defaultSettings);
    this.rest
      .CreatePHZTypeAgencyDefault(defaultSettings, this.currentCustomer, this.currentAgency)
      .toPromise()
      .then(
        (success) => {
          this.toastService.success('Agency Default Proximity has been created!', undefined, {
            autoDismiss: true && 3000,
          });
          let data: any;
          data = success;
          this.defaultSettings = data;
          console.log(this.defaultSettings);
        },
        (err: HttpErrorResponse) => {
          if (err.status === 400 || err.status === 500) {
            this.toastService.error('Create Default Proximity failed! - ' + err.error);
          } else {
            /* istanbul ignore else */
            if (err.status !== 404) {
              this.toastService.error('Create Default Proximity failed! - ' + err.statusText);
            }
            console.log(err);
          }
        }
      );
  }

  public switchAgency(CustomerId, AgencyId) {
    this.currentAgency = AgencyId;
    this.Schema = null;
    this.clearNewRow();
    /* istanbul ignore else */
    if (this.deleteTypeList.length) {
      this.deleteTypeList.pop();
    }
    this.typeProximityFormArray.clear();
    this.defaultSettings = {
      unitOfMeasure: 'Foot',
      agencyId: '',
      tenantKey: 0,
      id: 0,
      innerProximityDistance: 500,
      outerProximityDistance: 1000,
    };
    this.defaultInnerDistance = 500;
    this.defaultOuterDistance = 1000;
    this.defaultUnit = 'Foot';
    this.load_data(CustomerId, AgencyId);
  }

  public updateInnerDistance(typeproximity: FormGroup, value) {
    typeproximity.controls.InnerProximityDistance.setValue(
      value * this.rest.unitConvert.get(this.defaultSettings.unitOfMeasure)
    );
  }

  public updateOuterDistance(typeproximity: FormGroup, value) {
    typeproximity.controls.OuterProximityDistance.setValue(
      value * this.rest.unitConvert.get(this.defaultSettings.unitOfMeasure)
    );
  }
}
